export default {
	langs: {
		it: "Italiano",
		en: "English",
	},

	it: {
		abstract: "Sinossi",
		add: "Aggiungi",
		add_chapter: "Aggiungi capitolo",
		add_scene: "Aggiungi scena",
		add_track: "Aggiungi traccia",
		book: "Libro",
		char: "Battuta",
		character: "Personaggio",
		characters: "Personaggi",
		chars: "Battute",
		check_and_save: "Verifica e Salva",
		choose_folder: "Seleziona cartella",
		choose_server: "Seleziona server",
		copy_of: "Copia di",
		collapse: "Collassa",
		collapse_all: "Collassa tutti",
		completed: "Completato",
		conflict_hint: "Sul server è presente una versione diversa rispetto a quella che si sta salvando. Come si desidera procedere?",
		conflict_title: "Risolvi conflitto",
		conflict_overwrite: "Sovrascrivi file remoto",
		conflict_preserve: "Salva come copia",
		creation_date: "Data creazione",
		doc_loaded: "Libro caricato",
		doc_saved: "Libro salvato",
		draft: "Bozza iniziale",
		edit_scene: "Modifica scena",
		edit_section: "Modifica capitolo",
		edit_track: "Modifica traccia",
		empty_folder: "Cartella vuota",
		events: "Eventi",
		expand: "Espandi",
		expand_all: "Espandi tutti",
		export: "Esporta",
		export_epub: "Esporta ePub",
		extras: "Extra",
		final_draft: "Bozza finale",
		generic_error: "Si è verificato un errore",
		import: "Importa",
		language: "Lingua",
		last_edit: "Ultima modifica",
		load: "Carica",
		move_down: "Sposta in basso",
		move_left: "Sposta a sinistra",
		move_right: "Sposta a destra",
		move_up: "Sposta in alto",
		name: "Nome",
		new_book: "Nuovo libro",
		new_chapter: "Nuovo capitolo",
		new_doc: "Nuovo documento",
		new_scene: "Nuova scena",
		new_section: "Nuovo capitolo",
		next: "Avanti",
		no_element: "Nessun elemento presente",
		no_reference: "Nessun riferimento inserito",
		no_scene: "Nessuna scena",
		no_server_configured: "Nessun server configurato",
		note: "Note",
		objects: "Oggetti",
		open_doc: "Apri documento",
		paragraph: "Paragrafo",
		paragraphs: "Paragrafi",
		password: "Password",
		places: "Luoghi",
		references: "Riferimenti",
		remove: "Cancella",
		remove_chapter: "Rimuovi capitolo",
		remove_scene: "Rimuovi scena",
		reviewed_draft: "Bozza revisionata",
		scene: "Scena",
		scenes: "Scene",
		server: "Server",
		server_added: "Il server è stato aggiunto",
		server_changed: "Il server è stato modificato.",
		server_error: "Errore nella comunicazione col server. Verifica i parametri.",
		server_hint: "Puoi utilizzare un <a target=\"blank\" href=\"https://writer.caribe.cf/cloud-server-webdav\">server WebDAV</a> per salvare il tuo libro in cloud.",
		server_removed: "Il server è stato rimosso.",
		server_save_fail: "Salvataggio sul server fallito.",
		server_url: "URL Server",
		settings: "Impostazioni",
		status: "Stato",
		submit: "Esegui",
		summary: "Sommario",
		theme: "Tema",
		themes: "Temi",
		title: "Titolo",
		track: "Traccia",
		outdated_title: "File più recente sul server",
		outdated_hint: "Una versione più recente è disponibile sul server. Cosa vuoi fare?",
		outdated_reload: "Carica la versione sul server",
		username: "Username",
		website: "Sito web",
		word: "Parola",
		words: "Parole",
		write: "Scrivi",
	},
	en: {
		abstract: "Abstract",
		add: "Add",
		add_chapter: "Add chapter",
		add_scene: "Add scene",
		add_track: "Add track",
		book: "Book",
		char: "Char",
		character: "Character",
		characters: "Characters",
		chars: "Chars",
		check_and_save: "Check and Save",
		choose_folder: "Choose folder",
		choose_server: "Choose server",
		collapse: "Collapse",
		collapse_all: "Collapse all",
		completed: "Completed",
		conflict_hint: "A different update is already on the server. What want you do?",
		conflict_title: "Check conflict",
		conflict_overwrite: "Overwrite remote file",
		conflict_preserve: "Save as copy",
		copy_of: "Copy of",
		creation_date: "Creation date",
		doc_loaded: "Book loaded",
		doc_saved: "Book saved",
		draft: "Draft",
		edit_scene: "Edit scene",
		edit_section: "Edit chapter",
		edit_track: "Edit track",
		empty_folder: "Empty folder",
		events: "Events",
		expand: "Expand",
		expand_all: "Expand all",
		export: "Export",
		export_epub: "Export ePub",
		extras: "Extras",
		final_draft: "Final draft",
		generic_error: "An error occurred",
		import: "Import",
		language: "Language",
		last_edit: "Last edit",
		load: "Load",
		move_down: "Move down",
		move_left: "Move left",
		move_right: "Move right",
		move_up: "Move up",
		name: "Name",
		new_book: "New book",
		new_chapter: "New chapter",
		new_doc: "New document",
		new_scene: "New scene",
		next: "Next",
		no_element: "No element",
		no_reference: "No reference",
		no_scene: "No scenes",
		no_server_configured: "No server configured",
		note: "Note",
		objects: "Objects",
		open_doc: "Open document",
		paragraph: "Paragraph",
		paragraphs: "Paragraphs",
		password: "Password",
		places: "Places",
		references: "References",
		remove: "Remove",
		remove_chapter: "Remove chapter",
		remove_scene: "Remove scene",
		reviewed_draft: "Reviewed draft",
		scene: "Scene",
		scenes: "Scenes",
		server: "Server",
		server_added: "Server has been added",
		server_changed: "Server has been updated",
		server_error: "Comunication error with server. Check the configuration.",
		server_hint: "You can use a <a target=\"blank\" href=\"https://writer.caribe.cf/cloud-server-webdav\">WebDAV server</a> to store your book in the cloud.",
		server_removed: "Server has been removed",
		server_save_fail: "Something went wrong while saving on server",
		server_url: "URL Server",
		settings: "Settings",
		status: "Status",
		submit: "Submit",
		summary: "Summary",
		theme: "Theme",
		themes: "Themes",
		title: "Title",
		track: "Track",
		outdated_title: "More recent file on server",
		outdated_hint: "A more recent version in available on the server. What want you do?",
		outdated_reload: "Load version from server",
		username: "Username",
		website: "Website",
		word: "Word",
		words: "Words",
		write: "Write",
	},
}
